// extracted by mini-css-extract-plugin
export default {"host":"style_host__sQa9f","iconVerify":"style_iconVerify__gj+uh"};